<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-07-30 15:39:51
--> 
<template>
  <div>
    <staffVariation></staffVariation>
  </div>
</template> 
 
<script>
import staffVariation from './staffVariation'
export default {
  components: {
    staffVariation
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>